{
  "dropzoneLabel": "ドロップゾーン",
  "selectPlaceholder": "項目を選択",
  "tableResizer": "サイズ変更ツール",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
